<script>
import RegistrationCategorySeriesList from "../../RegistrationCategorySeries/List.vue";

export default {
    name: 'simple-boolean',

    components: {
        RegistrationCategorySeriesList,
    },

    props: {
        simpleBooleanDefault: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            simpleBoolean: this.simpleBooleanDefault,
        }
    },

    methods: {
        setSimpleBoolean(value) {
            this.simpleBoolean = value;
        },
    },

    watch: {
        simpleBoolean: {
            handler(value) {
                this.$emit('change', value);
            },
            // force eager callback execution
            immediate: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/InlineTemplates/SimpleBoolean.vue